import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 col-sm-12 col-xl" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card h-100\"><div class=\"card-body d-flex justify-content-center text-center flex-column p-8\"><a href=\"#\" class=\"text-gray-800 text-hover-primary d-flex flex-column\"><div class=\"symbol symbol-75px mb-6\"><img src=\"/media/svg/files/folder-document.svg\" alt=\"\"></div><div class=\"fs-5 fw-bolder mb-2\">Finance</div></a><div class=\"fs-7 fw-bold text-gray-400 mt-auto\">7 files</div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}